import { Injectable } from '@angular/core';
import { CrudService } from '../crud.service';
import { SiteCallTypeHeadingApiModel } from '../../api-models';

@Injectable()
export class SiteCallTypeHeadingsService extends CrudService<SiteCallTypeHeadingApiModel, number> {
  public apiUrl = 'site-call-type-headings';
}
